import InvestWithdrawForm from './InvestWithdrawFormNew';

export default InvestWithdrawForm;
